import script from "./SelectScreenNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectScreenNumber.vue?vue&type=script&setup=true&lang=js"

import "./SelectScreenNumber.vue?vue&type=style&index=0&id=fea0a08c&lang=css"

const __exports__ = script;

export default __exports__